import React from "react";
import {
  Box,
  Typography,
  Grid,
  Divider,
  IconButton,
  Tooltip,
  Stack,
  alpha,
  useTheme,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { toast } from "react-toastify";

import AppModal from "../common/AppModal";
import StatusChip from "../common/StatusChip";
import DetailItem from "../common/DetailItem";

const ViewLicenseModal = ({ open, onClose, license }) => {
  const theme = useTheme();

  if (!license) return null;

  const handleCopy = () => {
    navigator.clipboard.writeText(license.licenseKey).then(() => {
      toast.success("License Key copied to clipboard!");
    });
  };

  return (
    <AppModal open={open} onClose={onClose} title="License Details" width="sm">
      <Box>
        {/* BIG LICENSE KEY BLOCK */}
        <Box
          sx={{
            p: 3,
            mb: 3,
            bgcolor: alpha(theme.palette.primary.main, 0.1),
            border: `1px dashed ${theme.palette.primary.main}`,
            borderRadius: 2,
            textAlign: "center",
          }}
        >
          <Typography variant="overline" color="primary" fontWeight="bold">
            LICENSE KEY
          </Typography>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            spacing={1}
            mt={1}
          >
            <Typography
              variant="h5"
              sx={{
                fontFamily: "monospace",
                fontWeight: "bold",
                wordBreak: "break-all",
              }}
            >
              {license.licenseKey}
            </Typography>
            <Tooltip title="Copy Key">
              <IconButton onClick={handleCopy} color="primary">
                <ContentCopyIcon />
              </IconButton>
            </Tooltip>
          </Stack>
        </Box>

        <Grid container spacing={2}>
          <DetailItem
            label="Customer / Business"
            value={license.customerBusinessName}
          />
          <DetailItem label="Product" value={license.productName} />
          <DetailItem label="License Type" value={license.type} />
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              Status
            </Typography>
            <StatusChip status={license.status} />
          </Grid>
          <DetailItem
            label="Expiry Date"
            value={new Date(license.expiryDate).toLocaleString()}
          />
          <DetailItem
            label="Next Renewal"
            value={
              license.nextRenewalDate
                ? new Date(license.nextRenewalDate).toLocaleDateString()
                : "N/A"
            }
          />
          <DetailItem
            label="Renewal Price"
            value={Number(license.renewalPrice).toLocaleString(undefined, {
              minimumFractionDigits: 2,
            })}
          />
          <DetailItem
            label="Auto Renew"
            value={license.autoRenew ? "Enabled" : "Disabled"}
          />
          <DetailItem
            label="Machine ID"
            value={license.machineId || "Unassigned"}
          />
          <DetailItem label="Issued By" value={license.issuedBy} />
        </Grid>

        <Divider sx={{ my: 2 }} />
        <Typography variant="caption" color="text.secondary">
          Client Info: {license.clientInfo || "None provided"}
        </Typography>
      </Box>
    </AppModal>
  );
};
export default ViewLicenseModal;
